// TransactionCard.js
import React from 'react';
import transactionData from './transactionData.json';
import { MdContactPhone } from "react-icons/md";
import { IoCopyOutline } from "react-icons/io5";
import './TransactionCard.scss';

const TransactionCard = () => {
  const { rate, unit, total, payment_service, status, order_id, date_time } = transactionData.transaction;

  return (
    <div className="transaction-card">
      <div className="transaction-header">
        <span className="transaction-rate">{rate} | {unit}</span>
        <span className="transaction-total">{total}</span>
      </div>
      <div className="transaction-status">
        <span className="transaction-amount">111.00</span>
        <span className="transaction-status-text">{status}</span>
      </div>
      <hr className="divider" />
      <div className="transaction-details">
        <span className="transaction-label">{status}</span>
        <div className="payment-service">
          <MdContactPhone className="icon" />
          <span className="payment-service-text">{payment_service}</span>
        </div>
      </div>
      <hr className="divider" />
      <div className="transaction-info">
        <div className="transaction-labels">
          <span className="label">trading order</span>
          <span className="label">order time</span>
        </div>
        <hr className="sub-divider" />
        <div className="transaction-order">
          <div className="order-id">
            <span className="label">trading order</span>
            <span className="order-id-text">{order_id} <IoCopyOutline className="icon" /></span>
          </div>
          <hr className="sub-divider" />
          <div className="order-time">
            <span className="label">order time</span>
            <span className="date-time">{date_time}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionCard;
